import { Script } from 'nordic/script';
import { oneOf, string } from 'prop-types';

import { getServerSideProps, setPageSettings } from '../../../server/hooks/vip';
import { VIP_LAYOUTS_COMPONENTS, VIP_VERTICALS } from '../../../utils/vipLayouts';

/* Base Page */
import VipBase from '../ui-components/views/VipBase';

const VipDesktop = props => {
  const { vertical, deviceType } = props;
  const Component = VIP_LAYOUTS_COMPONENTS[vertical][deviceType];

  return (
    <VipBase {...props}>
      <Script src="drift-zoom/dist/Drift.min.js" priority={1} on="now" inline />
      <Component {...props} />
    </VipBase>
  );
};

VipDesktop.propTypes = {
  deviceType: string.isRequired,
  vertical: oneOf(Object.values(VIP_VERTICALS)),
};

export { getServerSideProps, setPageSettings };

export const hydrate = 'hydrateRoot';

export default VipDesktop;
